import React from 'react';
import { ChartZone, MgpGaugeChart } from '../../components/MgpGaugeChart/MgpGaugeChart';
import { SummaryChartLoading } from './SummaryChartLoading';
import { SummaryChartRange } from './SummaryChartStyles';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';

export interface SummaryChartData {
  value: number;
  avgReturn: string;
  badTiming: string;
  targetZone: {
    color: string;
    status: string;
  };
  targetRange: {
    low: number;
    high: number;
  };
  zones: ChartZone[];
}

interface Props {
  title?: string;
  data?: SummaryChartData;
  isLoading?: boolean;
}

export const SummaryChart: React.FC<Props> = ({ title, data, isLoading }) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isLoading) {
    return <SummaryChartLoading title={title} />;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" my="16">
      {!isEmbeddedMobile && (
        <Text fontSize="h6" fontWeight={600}>
          {title}
        </Text>
      )}
      {data ? (
        <>
          <Box display="flex">
            <Box py="16" px={isEmbeddedMobile ? '24' : '48'} display="flex" flexDirection="column">
              <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
                Average Return
              </Text>

              <Text variant="tabular" fontWeight={500} fontSize="h5">
                {data.avgReturn}
              </Text>
            </Box>
            <Box py="16" px={isEmbeddedMobile ? '24' : '48'} display="flex" flexDirection="column">
              <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
                Bad Timing
              </Text>

              <Text variant="tabular" fontWeight={500} fontSize="h5">
                {data.badTiming}
              </Text>
            </Box>
          </Box>
          <MgpGaugeChart
            data={{ value: data.value, zones: data.zones, targetZone: data.targetZone }}
          />
          <SummaryChartRange>{`${data.targetRange.low}% - ${data.targetRange.high}%`}</SummaryChartRange>
        </>
      ) : (
        <MgpGaugeChart />
      )}
    </Box>
  );
};
